interface SimpleBeforeAfterProps {
  before: string;
  after: string;
  beforeAlt: string;
  afterAlt: string;
}

const SimpleBeforeAfter = ({ before, after, beforeAlt, afterAlt }: SimpleBeforeAfterProps) => {
  return (
    <div className="relative w-full h-full animate-fade-in">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-0 h-full">
        {/* Before Image */}
        <div className="relative h-full min-h-[300px] md:min-h-[500px] bg-muted/50">
          <img
            src={before}
            alt={beforeAlt}
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {/* Before Badge */}
          <div className="absolute top-4 left-4 z-10">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-muted/95 to-muted/90 backdrop-blur-sm text-foreground font-semibold text-sm shadow-lg border border-border/50">
              😢 Before
            </span>
          </div>
        </div>

        {/* After Image */}
        <div className="relative h-full min-h-[300px] md:min-h-[500px] bg-muted/50">
          <img
            src={after}
            alt={afterAlt}
            className="w-full h-full object-cover"
            loading="lazy"
          />
          {/* After Badge */}
          <div className="absolute top-4 right-4 z-10">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-primary via-primary/90 to-accent backdrop-blur-sm text-primary-foreground font-semibold text-sm shadow-lg">
              ✨ After
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleBeforeAfter;
